// Use CopilotKit's Sidebar UI per quickstart
import '@copilotkit/react-ui/styles.css';
import { CopilotSidebar } from '@copilotkit/react-ui';
import { useCopilot } from './CopilotProvider';

const CopilotChat = ({ title = 'BrandSek AI Assistant', defaultOpen = false }) => {
  const { isAuthenticated } = useCopilot();
  if (!isAuthenticated) return null; // Hide when not logged in
  return (
    <div className="brandsek-copilot-ui">
      <CopilotSidebar
        instructions={"You are BrandSek's security assistant. Provide concise, actionable answers."}
        defaultOpen={false}
        labels={{ title, initial: "Hi! I'm connected to an agent. How can I help?" }}
      />
    </div>
  );
};

export default CopilotChat;
